import React, { useMemo, useState } from 'react'
import '../spare/about-spare.scss'
import SpinWithMessage from '../../common/spinners/SpinWithMessage'
import { customerAxios } from '../../../config/axios'
import toast from 'react-hot-toast'
import CUServiceWork from './CUServiceWork'
import Modal from '../../common/modal/Modal'
import UpdatePackageRate from './UpdatePackageRate'


const AboutServiceWork = ({ workId }) => {
    const [loading, setLoading] = useState('')
    const [data, setData] = useState({})
    const [modal, setModal] = useState({})

    useMemo(() => {
        setLoading('fetch')
        customerAxios.get(`/production-v0/service-work/${workId}`)
            .then((response) => {
                setData(response.data || {})
                setLoading('')
            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })

    }, [workId])

    const openEditModel = () => {
        setModal({
            status: true, title: "Edit service work", width: '600px',
            content: <CUServiceWork currentData={data} setModal={setModal} setData={setData} isEdit={true} />
        })
    }

    const openPackageRateModel = () => {
        setModal({
            status: true, title: "Update Package Rate", width: '600px',
            content: <UpdatePackageRate work_id={data?.work_id} currentData={data?.package_prices} setModal={setModal} />
        })
    }

    const handleChangeStatus = () => {
        const ask = window.confirm(`Are you ready to ${data?.is_active ? 'Inactive' : "Active"} ?`)

        if (ask) {
            customerAxios.patch(`/production-v0/service-work/${data?.work_id}/status`, {
                is_active: data?.is_active ? false : true
            }).then(() => {
                setModal({ status: false })
                toast.success(`Work Status Updated!`)

                setData({
                    ...data,
                    is_active: data?.is_active ? false : true
                })

            }).catch((error) => {
                toast.error(error.message)
            })
        }
    }

    return (
        loading === 'fetch'
            ? <SpinWithMessage message='Loading...' height={'250px'} />
            : <div className="about-spare-container">
                <Modal modal={modal} setModal={setModal} />
                <div className="buttons">
                    {data?.pricing_source !== 'PRODUCT_RENTAL' && <>
                        <button onClick={() => openEditModel()}>Edit Work</button>
                        <button onClick={() => openPackageRateModel()}>Edit Package Price</button>
                    </>}
                    <button style={{ backgroundColor: data?.is_active ? 'red' : "green" }} onClick={handleChangeStatus}>
                        {data?.is_active ? 'Deactivate' : "Activate"}
                    </button>
                </div>

                <div className="list-border-div">
                    <div className="list-title">
                        <h4>Service Work</h4>
                    </div>
                    <div className="title-content">
                        <div className="list-div">
                            <div className="one-div">
                                <p>Work ID</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.work_id}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Work Name</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.work_name}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Applicable For</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.applicable_for}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Pricing Source</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.pricing_source}</p>
                            </div>
                        </div>
                        {data?.pricing_source !== 'PRODUCT_RENTAL' && <>
                            <div className="list-div">
                                <div className="one-div">
                                    <p>Selling Rate (SR)</p>
                                </div>
                                <div className="two-div">
                                    <p>: ₹{data?.selling_rate || 0}</p>
                                </div>
                            </div>
                            <div className="list-div">
                                <div className="one-div">
                                    <p>Purchase Cost (PC)</p>
                                </div>
                                <div className="two-div">
                                    <p>: ₹{data?.purchase_cost || 0}</p>
                                </div>
                            </div>
                        </>}
                        <div className="list-div">
                            <div className="one-div">
                                <p>Call Rate</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.call_rate || '0'}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Refill Included</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.refill_included ? 'Yes' : 'No'}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Rent renewal </p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.rent_renewal_included ? 'Yes' : 'No'}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Reinstallation included</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.reinstallation_included ? 'Yes' : 'No'}</p>
                            </div>
                        </div>
                        <div className="list-div credit-amt">
                            <div className="one-div">
                                <p>Spare Status</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.is_active ? 'ACTIVE' : "INACTIVE"}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {data?.pricing_source !== 'PRODUCT_RENTAL' &&
                    <div className="list-border-div">
                        <div className="list-title">
                            <h4>Package Prices (P2)</h4>
                        </div>
                        {data?.package_prices?.length > 0
                            ? <>
                                <div className="title-content">
                                    {data?.package_prices?.map((pp) => {
                                        return <div className="list-div">
                                            <div className="one-div">
                                                <p>{pp?.package_name}</p>
                                            </div>
                                            <div className="two-div">
                                                <p>: {pp?.price}</p>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </>
                            : <p>Nil</p>}
                    </div>}
            </div>
    )
}

export default AboutServiceWork